'use client';

import React from 'react';

import { Button, Typography } from 'lighthouse';

import SwipeableDrawer from '@/widgets/SwipeableDrawer';

import { DeliveryMethods } from '../DeliveryMethods';
import { MobileDeliverySheetProps } from './models';

import { Shop } from 'iconsax-react';

export const MobileDeliverySheet = ({
    open,
    onClose,
    seller,
    value,
    onChange,
    otherVendorsCount,
    onSwitchSeller,
    disabled = false,
    unavailable = false
}: MobileDeliverySheetProps) => {
    const handleChange = (profile: Parameters<typeof onChange>[0]) => {
        if (disabled) return;
        onChange(profile);
        setTimeout(onClose, 150);
    };

    return (
        <SwipeableDrawer title={<Typography fontWeight={700}>روش تحویل و فروشنده</Typography>} open={open} onClose={onClose}>
            <div className='flex flex-col gap-4 p-2'>
                <DeliveryMethods compact seller={seller} value={value} onChange={handleChange} disabled={disabled} unavailable={unavailable} />

                {otherVendorsCount > 0 && (
                    <>
                        <hr className='opacity-10' />
                        <Button
                            variant='text'
                            startIcon={<Shop size={18} color='currentcolor' />}
                            onClick={() => {
                                onClose();
                                onSwitchSeller();
                            }}
                            className='!min-h-11'>
                            تغییر فروشنده ({otherVendorsCount} فروشنده دیگر)
                        </Button>
                    </>
                )}
            </div>
        </SwipeableDrawer>
    );
};
